import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { useFormik, FormikProvider } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { ROUTES } from "../../routes/routes.constants";
import EmailInput from "../../common_components/EmailInput";
import "../../App.css";
import ValidationMessage from "../../common_components/Validation";
import { emailRegex } from "../../helper/regex";
import CustomLoader from '../../common_components/CustomLoader';
import { ApiCall } from "../../helper/axios";
import AuthErrorBanner from "./AuthErrorBanner";
import AppButton from "../../common_components/AppButton";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/authSlice";
const validationSchema = Yup.object({
    email: Yup.string()
        .trim()
        .required(ValidationMessage.emailRequired)
        .matches(emailRegex, ValidationMessage.emailInvalid)
        .email(ValidationMessage.emailInvalid),
});
export default function ForgotPassword() {
    const [apiError, setApiError] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(logout());
    }, []);
    const formik = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            if (formik.isValid) {
                try {
                    const res = await ApiCall('POST', "/api/auth/forgot-password", values);
                    if (res?.data?.success && res?.status === 200) {
                        setApiError(null);
                        navigate(ROUTES.login.path, { state: 'A password reset link has been sent to your email address.' });
                    }
                    else {
                        const msg = res?.response?.data?.message || 'Something went wrong';
                        setApiError({ title: msg, description: "Please try again." });
                        formik.setSubmitting(false);
                    }
                }
                catch (error) {
                    setApiError({ title: 'Failed to send reset link. Please try again.', description: "" });
                    formik.setSubmitting(false);
                }
            }
        },
    });
    const handleChange = (name, e) => {
        const value = e?.target?.value || '';
        formik.setFieldValue(name, value);
        if (apiError)
            setApiError(null);
    };
    const handleBlur = (name) => {
        formik.setFieldTouched(name, true);
    };
    return (_jsxs(Box, { className: "login-page-container", children: [_jsx(Box, { className: "login-logo-container", sx: { display: 'flex', alignItems: 'center', gap: '10px' }, children: _jsx("img", { alt: "GROUP 8A Logo", src: "/assets/loginImage/logo-final.svg", className: "login-logo-img" }) }), _jsx(Paper, { elevation: 0, className: "login-form-card", children: _jsx(FormikProvider, { value: formik, children: _jsxs(Box, { component: "form", onSubmit: formik.handleSubmit, className: "login-form", children: [_jsxs(Box, { className: "login-header", children: [_jsx(Typography, { variant: "h4", className: "login-title", children: "Forgot Your Password?" }), _jsx(Typography, { variant: "body1", className: "login-subtitle", children: "Enter your email address to receive a reset link." })] }), _jsxs(Box, { className: "login-form-fields", children: [_jsx(Box, { className: "login-form-inputs-wrapper", children: _jsxs(Box, { className: "login-form-inputs", children: [apiError && (_jsx(Box, { sx: { paddingBottom: '15px', width: '100%' }, children: _jsx(AuthErrorBanner, { message: apiError }) })), _jsx(Box, { sx: { paddingBottom: '15px', width: '100%' }, children: _jsx(EmailInput, { label: "Email", placeholder: "Enter email", type: "email", value: formik.values.email, onChange: (e) => handleChange('email', e), onBlur: (e) => handleBlur('email'), autoComplete: "off", errors: formik.errors.email, touched: formik.touched.email, maxLength: 50 }) })] }) }), _jsx(Box, { className: "login-signin-button-container", children: _jsx(AppButton, { type: "submit", fullWidth: true, className: "login-signin-button", variant: "contained", color: "primary", disabled: formik.isSubmitting, children: formik.isSubmitting ? _jsx(CustomLoader, { sx: { color: 'white' } }) : 'Submit' }) }), _jsx(Box, { className: "login-forgot-password-container back-to-login", children: _jsx(AppButton, { children: "Back to Login", onClick: () => navigate(ROUTES.login.path, { replace: true }), className: "login-forgot-password-link" }) })] })] }) }) }), _jsx("div", { className: "bird-container bird-container--one", children: _jsx("div", { className: "bird bird--one", children: "\u00A0" }) }), _jsx("div", { className: "bird-container bird-container--two", children: _jsx("div", { className: "bird bird--two", children: "\u00A0" }) }), _jsx("div", { className: "bird-container bird-container--three", children: _jsx("div", { className: "bird bird--two", children: "\u00A0" }) }), _jsx("div", { className: "bird-container bird-container--four", children: _jsx("div", { className: "bird bird--two", children: "\u00A0" }) })] }));
}
